import { AuthProviderProps } from "react-oidc-context";

// src/config.ts
interface AppConfig {
    REACT_APP_API_BASE_URL: string;
    COGNITO_CFG: AuthProviderProps;
  }
  
  let config: AppConfig;
  
  export const loadConfig = async (): Promise<void> => {
    const response = await fetch(`${process.env.PUBLIC_URL}/config.json`);
    config = await response.json();
  };
  
  export const getConfig = (): AppConfig => {
    if (!config) {
      throw new Error("Configuration has not been loaded. Make sure to call `loadConfig` first.");
    }
    return config;
  };